import React from 'react';

function Banner() {
  return (
    <div
      className="py-[100px] px-10 font-poppins text-white"
      style={{ backgroundColor: 'var(--background-secondary-color)' }}
    >
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-x-6 gap-y-8">
        <div className="md:w-1/2 text-center md:text-left">
          <h2 className="text-headers-font-size font-poppins font-semibold mb-4">
            Add some advertisement{' '}
          </h2>
          <p className="text-paragraph-font-size font-poppins text-white">
            Upgrade your skills with our premium courses. Enroll now and access
            exclusive content!
          </p>
        </div>
      </div>
    </div>
  );
}

export default Banner;
